import {Component, EventEmitter, Input, OnInit, Output, ViewChild} from '@angular/core';
import {LoginService} from '../../../shared/services/login.service';
import {FeeService} from '../../../shared/services/fee.service';
import {SERVICE_PROVIDER} from '../../../shared/services/fee.service';
import {FormControl, Validators} from '@angular/forms';
import {WorkrequestCmpViewmodel} from '../workrequest-cmp-viewmodel';
import {WorkrequestCmpDetails} from '../workrequest-cmp-details';
import {RefDataItem, RefDataType} from '../../../shared/data-objects/ref-data-item';
import {RefDataDropdownComponent} from '../../../shared/components/ref-data-dropdown/ref-data-dropdown.component';
import {RefDataService} from '../../../shared/services/ref-data.service';
import {AddressService} from '../../../shared/services/address.service';

@Component({
  selector: 'app-workrequest-cmp',
  templateUrl: './workrequest-cmp.component.html',
  styleUrls: ['./workrequest-cmp.component.css']
})
export class WorkrequestCmpComponent implements OnInit {
  @Input()
  isReadOnly = false;
  @Input()
  workRequestViewModel: WorkrequestCmpViewmodel;
  @Input()
  fire = false;
  @Input()
  isRecycledWaterZone = false;
  @Output()
  onViewModelChange: EventEmitter<WorkrequestCmpViewmodel>;
  @Output()
  onFeeCodesReceived: EventEmitter<void>;

  @ViewChild('zone') zones: RefDataDropdownComponent;
  TappingSizeValues: any;
  serviceTappingSelectedControl: FormControl;
  serviceTappingSizeControl: FormControl;
  serviceTappingFlowControl: FormControl;
  serviceTappingQtyControl: FormControl;

  // fireServiceSelectedControl: FormControl;
  // fireServiceSizeControl: FormControl;
  // fireServiceFlowControl: FormControl;
  // fireServiceQtyControl: FormControl;

  mainMeterSelectedControl: FormControl;
  mainMeterSizeControl: FormControl;
  mainMeterFlowControl: FormControl;
  mainMeterQtyControl: FormControl;

  checkMeterRSelectedControl: FormControl;
  checkMeterRSizeControl: FormControl;
  checkMeterRQtyControl: FormControl;

  checkMeterCSelectedControl: FormControl;
  checkMeterCSizeControl: FormControl;
  checkMeterCQtyControl: FormControl;

  existingServiceSelectedControl: FormControl;
  existingServiceDetailsControl: FormControl;

  existingMeterNumbersSelectedControl: FormControl;
  existingMeterNumbersControl: FormControl;

  recycledTappingSelectedControl: FormControl;
  recycledTappingSizeControl: FormControl;
  recycledTappingFlowControl: FormControl;
  recycledTappingQtyControl: FormControl;

  recycledMainMeterSelectedControl: FormControl;
  recycledMainMeterSizeControl: FormControl;

  recycledCheckMeterRSelectedControl: FormControl;
  recycledCheckMeterRSizeControl: FormControl;

  connectingToExistingSewerControl: FormControl;
  connectingToNewSewerControl: FormControl;
  dischargeOfTradeWasteControl: FormControl;

  descriptionOfWorkControl: FormControl;
  propertyOnCombinedDrainYesControl: FormControl;
  propertyOnCombinedDrainNoControl: FormControl;

  descriptionOfWorkControlMaxLength = 400;

  maximumServiceSize = 200;
  maximumServiceFlowRate = 75;
  maximumServiceQty = 20;

  // maximumFireServiceSize = 200;
  // maximumFireServiceFlowRate = 40;
  // maximumFireServiceQty = 20;

  maximumMainMeterSize = 200;
  maximumMainMeterFlowRate = 40;
  maximumMainMeterQty = 20;

  maximumCheckMeterRSize = 100;
  maximumCheckMeterRQty = 2000;

  maximumCheckMeterCSize = 100;
  maximumCheckMeterCQty = 2000;
  existingWaterServiceControlMaxLength = 100;

  maximumRecycledTappingSize = 150;
  maximumRecycledTappingFlowRate = 50;
  maximumRecycledTappingQty = 20;

  maximumRecycledMainMeterSize = 100;
  maximumRecycledCheckMeterRSize = 100;
  existingMeterNumbersControlMaxLength = 100;

  pricingZone: string = SERVICE_PROVIDER.CWW;

  constructor(private loginService: LoginService, private addressService: AddressService,
    private feeService: FeeService, private refDataService: RefDataService) {

    if (!this.workRequestViewModel) {
      this.workRequestViewModel = new WorkrequestCmpViewmodel();
    }
    if (!this.workRequestViewModel.workrequestDetails) {
      this.workRequestViewModel.workrequestDetails = new WorkrequestCmpDetails();
    }

    this.onFeeCodesReceived = new EventEmitter();

    this.serviceTappingSelectedControl = new FormControl();
    this.serviceTappingSizeControl = new FormControl();
    // '', [Validators.compose([Validators.min(0), Validators.max(this.maximumServiceSize)])]);
    this.serviceTappingFlowControl = new FormControl('',
      [Validators.compose([Validators.min(0), Validators.max(this.maximumServiceFlowRate)])]);
    this.serviceTappingQtyControl = new FormControl('',
      [Validators.compose([Validators.min(0), Validators.max(this.maximumServiceQty)])]);

    // this.fireServiceSelectedControl = new FormControl();
    // this.fireServiceSizeControl = new FormControl('',
    //   [Validators.compose([Validators.min(0), Validators.max(this.maximumFireServiceSize)])]);
    // this.fireServiceFlowControl = new FormControl('',
    //   [Validators.compose([Validators.min(0), Validators.max(this.maximumFireServiceFlowRate)])]);
    // this.fireServiceQtyControl = new FormControl('',
    //   [Validators.compose([Validators.min(0), Validators.max(this.maximumFireServiceQty)])]);

    this.mainMeterSelectedControl = new FormControl();
    this.mainMeterSizeControl = new FormControl('',
      [Validators.compose([Validators.min(0), Validators.max(this.maximumMainMeterSize)])]);
    this.mainMeterFlowControl = new FormControl('',
      [Validators.compose([Validators.min(0), Validators.max(this.maximumMainMeterFlowRate)])]);
    this.mainMeterQtyControl = new FormControl('',
      [Validators.compose([Validators.min(0), Validators.max(this.maximumMainMeterQty)])]);

    this.checkMeterRSelectedControl = new FormControl();
    this.checkMeterRSizeControl = new FormControl('',
      [Validators.compose([Validators.min(0), Validators.max(this.maximumCheckMeterRSize)])]);
    this.checkMeterRQtyControl = new FormControl('',
      [Validators.compose([Validators.min(0), Validators.max(this.maximumCheckMeterRQty)])]);
    this.checkMeterCSelectedControl = new FormControl();
    this.checkMeterCSizeControl = new FormControl('',
      [Validators.compose([Validators.min(0), Validators.max(this.maximumCheckMeterCSize)])]);
    this.checkMeterCQtyControl = new FormControl('',
      [Validators.compose([Validators.min(0), Validators.max(this.maximumCheckMeterCQty)])]);

    this.existingServiceSelectedControl = new FormControl();
    this.existingServiceDetailsControl = new FormControl('',
      [Validators.maxLength(this.existingWaterServiceControlMaxLength)]);

    this.existingMeterNumbersSelectedControl = new FormControl();
    this.existingMeterNumbersControl = new FormControl('', [Validators.compose([
      Validators.required,
      Validators.maxLength(this.existingMeterNumbersControlMaxLength)
    ])]);


    this.recycledTappingSelectedControl = new FormControl();
    this.recycledTappingSizeControl = new FormControl('',
      [Validators.compose([Validators.min(0), Validators.max(this.maximumRecycledTappingSize)])]);
    this.recycledTappingFlowControl = new FormControl('',
      [Validators.compose([Validators.min(0), Validators.max(this.maximumRecycledTappingFlowRate)])]);
    this.recycledTappingQtyControl = new FormControl('',
      [Validators.compose([Validators.min(0), Validators.max(this.maximumRecycledTappingQty)])]);

    this.recycledMainMeterSelectedControl = new FormControl();
    this.recycledMainMeterSizeControl = new FormControl('',
      [Validators.compose([Validators.min(0), Validators.max(this.maximumRecycledMainMeterSize)])]);


    this.recycledCheckMeterRSelectedControl = new FormControl();
    this.recycledCheckMeterRSizeControl = new FormControl('',
      [Validators.compose([Validators.min(0), Validators.max(this.maximumRecycledCheckMeterRSize)])]);

    this.connectingToExistingSewerControl = new FormControl();
    this.connectingToNewSewerControl = new FormControl();
    this.dischargeOfTradeWasteControl = new FormControl();
    this.propertyOnCombinedDrainYesControl = new FormControl();
    this.propertyOnCombinedDrainNoControl = new FormControl();
    this.descriptionOfWorkControl = new FormControl('', [Validators.compose([
      Validators.required,
      Validators.maxLength(this.descriptionOfWorkControlMaxLength)
    ])]);

    // fetch pricing zone (CWW / WW)
    this.addressService.getPricingZone().subscribe(_pricingzone => {
      this.pricingZone = _pricingzone.toUpperCase() === SERVICE_PROVIDER.WW ? SERVICE_PROVIDER.WW : SERVICE_PROVIDER.CWW;
      console.log('PrizeZone:', this.pricingZone);
    }, err => {
      this.pricingZone = SERVICE_PROVIDER.CWW;
    });
  }

  ngOnInit() {
    // this.loadFees();

    const pleaseSelect: RefDataItem[] = [new RefDataItem(0, 'Please Select...')];
    this.refDataService.retrieveReferenceData(RefDataType.Zones, this.loginService.getToken()).subscribe(
      (refDataItems) => {
        if (this.zones) {
          this.zones.items = pleaseSelect.concat(refDataItems);
          this.zones.selectedItemId = (<WorkrequestCmpDetails>this.workRequestViewModel.workrequestDetails).currentZoningSelectedItemId ?
            (<WorkrequestCmpDetails>this.workRequestViewModel.workrequestDetails).currentZoningSelectedItemId : 0;
        }
      },
      err => {
        this.errorMessage = 'Server error';
      });

      this.refDataService.retrieveReferenceData(RefDataType.CMPTappingandMeterSize,this.loginService.getToken()).subscribe((refDataItems: any) => {
        this.TappingSizeValues = refDataItems;
       
      });
  }

  // private loadFees(): void {
  //   this.feeService.retrieveFees('ComplexPlumbing', this.loginService.getToken(), ok => {
  //       if (ok) {
  //         this.workRequestViewModel.applicationFeeAmount = this.feeService.getCMPApplicationFeeAmount(this.pricingZone);
  //         this.onFeeCodesReceived.emit();
  //       } else {
  //         console.log('no fees found');
  //       }
  //     },
  //     err => {
  //       // Log errors if any
  //       console.log(err);
  //     });
  // }

  get invalid(): boolean {
    return this.descriptionOfWorkControl.invalid || !this.selectedZone;
  }

  public handleZoneChanged($event) {
    const selectedItem: RefDataItem = this.zones.selectedItem;
    if (selectedItem) {
      (<WorkrequestCmpDetails>this.workRequestViewModel.workrequestDetails).zone = selectedItem.display;
      if (typeof selectedItem.id === 'number' || typeof selectedItem.id === 'string') {
        (<WorkrequestCmpDetails>this.workRequestViewModel.workrequestDetails).currentZoningSelectedItemId = <number>(selectedItem.id);
      }
    }
  }

  
  get isPropertyOnCombinedDrain(): string {
    switch (this.propertyOnCombinedDrain) {
      case 'yes':
        return 'Yes';
      case 'no':
        return 'No';
      default:
        return 'None';
    }
  }

  get selectedZone(): string {
    return (<WorkrequestCmpDetails>this.workRequestViewModel.workrequestDetails).zone
      ? (<WorkrequestCmpDetails>this.workRequestViewModel.workrequestDetails).zone : '';
  }

  get propertyOnCombinedDrain(): string {
    return this.workRequestViewModel.propertyOnCombinedDrain;
  }
  set propertyOnCombinedDrain(v: string) {
   this.workRequestViewModel.propertyOnCombinedDrain = v;
   
  }

  set applicationFeeAmount(v: number) {
    this.workRequestViewModel.applicationFeeAmount = v;
    this.workRequestViewModel.workrequestDetails.totalOrderAmount = v;
  }

  get applicationFeeAmount(): number {
    return this.workRequestViewModel.applicationFeeAmount;
  }

  get serviceTappingSelected(): boolean {
    return this.workRequestViewModel.serviceTappingSelected;
  }

  set serviceTappingSelected(v: boolean) {
    this.workRequestViewModel.serviceTappingSelected = v;
  }

  get serviceTappingSize(): number {
    return this.workRequestViewModel.serviceTappingSize;
  }

  set serviceTappingSize(v: number) {
    this.workRequestViewModel.serviceTappingSize = v;
  }

  get serviceTappingFlow(): number {
    return this.workRequestViewModel.serviceTappingFlow;
  }

  set serviceTappingFlow(v: number) {
    this.workRequestViewModel.serviceTappingFlow = v;
  }

  get serviceTappingQty(): number {
    return this.workRequestViewModel.serviceTappingQty;
  }

  set serviceTappingQty(v: number) {
    this.workRequestViewModel.serviceTappingQty = v;
  }

  // get fireServiceSelected(): boolean {
  //   return this.workRequestViewModel.fireServiceSelected;
  // }

  // set fireServiceSelected(v: boolean) {
  //   this.workRequestViewModel.fireServiceSelected = v;
  // }

  // get fireServiceSize(): number {
  //   return this.workRequestViewModel.fireServiceSize;
  // }

  // set fireServiceSize(v: number) {
  //   this.workRequestViewModel.fireServiceSize = v;
  // }

  // get fireServiceFlow(): number {
  //   return this.workRequestViewModel.fireServiceFlow;
  // }

  // set fireServiceFlow(v: number) {
  //   this.workRequestViewModel.fireServiceFlow = v;
  // }

  // get fireServiceQty(): number {
  //   return this.workRequestViewModel.fireServiceQty;
  // }

  // set fireServiceQty(v: number) {
  //   this.workRequestViewModel.fireServiceQty = v;
  // }

  get mainMeterSelected(): boolean {
    return this.workRequestViewModel.mainMeterSelected;
  }

  set mainMeterSelected(v: boolean) {
    this.workRequestViewModel.mainMeterSelected = v;
  }

  get mainMeterSize(): number {
    return this.workRequestViewModel.mainMeterSize;
  }

  set mainMeterSize(v: number) {
    this.workRequestViewModel.mainMeterSize = v;
  }

  get mainMeterFlow(): number {
    return this.workRequestViewModel.mainMeterFlow;
  }

  set mainMeterFlow(v: number) {
    this.workRequestViewModel.mainMeterFlow = v;
  }

  get mainMeterQty(): number {
    return this.workRequestViewModel.mainMeterQty;
  }

  set mainMeterQty(v: number) {
    this.workRequestViewModel.mainMeterQty = v;
  }

  get checkMeterRSelected(): boolean {
    return this.workRequestViewModel.checkMeterRSelected;
  }

  set checkMeterRSelected(v: boolean) {
    this.workRequestViewModel.checkMeterRSelected = v;
  }

  get checkMeterRSize(): number {
    return this.workRequestViewModel.checkMeterRSize;
  }

  set checkMeterRSize(v: number) {
    this.workRequestViewModel.checkMeterRSize = v;
  }

  get checkMeterRQty(): number {
    return this.workRequestViewModel.checkMeterRQty;
  }

  set checkMeterRQty(v: number) {
    this.workRequestViewModel.checkMeterRQty = v;
  }

  get checkMeterCSelected(): boolean {
    return this.workRequestViewModel.checkMeterCSelected;
  }

  set checkMeterCSelected(v: boolean) {
    this.workRequestViewModel.checkMeterCSelected = v;
  }

  get checkMeterCSize(): number {
    return this.workRequestViewModel.checkMeterCSize;
  }

  set checkMeterCSize(v: number) {
    this.workRequestViewModel.checkMeterCSize = v;
  }

  get checkMeterCQty(): number {
    return this.workRequestViewModel.checkMeterCQty;
  }

  set checkMeterCQty(v: number) {
    this.workRequestViewModel.checkMeterCQty = v;
  }

  get existingServiceSelected(): boolean {
    return this.workRequestViewModel.existingServiceSelected;
  }

  set existingServiceSelected(v: boolean) {
    this.workRequestViewModel.existingServiceSelected = v;
  }

  get existingServiceDetails(): string {
    return this.workRequestViewModel.existingServiceDetails;
  }

  set existingServiceDetails(v: string) {
    this.workRequestViewModel.existingServiceDetails = v;
  }

  get existingMeterNumbersSelected(): boolean {
    return this.workRequestViewModel.existingMeterNumbersSelected;
  }

  set existingMeterNumbersSelected(v: boolean) {
    this.workRequestViewModel.existingMeterNumbersSelected = v;
  }

  get existingMeterNumbers(): string {
    return this.workRequestViewModel.existingMeterNumbers;
  }

  set existingMeterNumbers(v: string) {
    this.workRequestViewModel.existingMeterNumbers = v;
  }

  get recycledTappingSelected(): boolean {
    return this.workRequestViewModel.recycledTappingSelected;
  }

  set recycledTappingSelected(v: boolean) {
    this.workRequestViewModel.recycledTappingSelected = v;
  }

  get recycledTappingSize(): number {
    return this.workRequestViewModel.recycledTappingSize;
  }

  set recycledTappingSize(v: number) {
    this.workRequestViewModel.recycledTappingSize = v;
  }

  get recycledTappingFlow(): number {
    return this.workRequestViewModel.recycledTappingFlow;
  }

  set recycledTappingFlow(v: number) {
    this.workRequestViewModel.recycledTappingFlow = v;
  }

  get recycledTappingQty(): number {
    return this.workRequestViewModel.recycledTappingQty;
  }

  set recycledTappingQty(v: number) {
    this.workRequestViewModel.recycledTappingQty = v;
  }

  get recycledMainMeterSelected(): boolean {
    return this.workRequestViewModel.recycledMainMeterSelected;
  }

  set recycledMainMeterSelected(v: boolean) {
    this.workRequestViewModel.recycledMainMeterSelected = v;
  }

  get recycledMainMeterSize(): number {
    return this.workRequestViewModel.recycledMainMeterSize;
  }

  set recycledMainMeterSize(v: number) {
    this.workRequestViewModel.recycledMainMeterSize = v;
  }

  get recycledCheckMeterRSelected(): boolean {
    return this.workRequestViewModel.recycledCheckMeterRSelected;
  }

  set recycledCheckMeterRSelected(v: boolean) {
    this.workRequestViewModel.recycledCheckMeterRSelected = v;
  }

  get recycledCheckMeterRSize(): number {
    return this.workRequestViewModel.recycledCheckMeterRSize;
  }

  set recycledCheckMeterRSize(v: number) {
    this.workRequestViewModel.recycledCheckMeterRSize = v;
  }

  get connectingToExistingSewer(): boolean {
    return (<WorkrequestCmpDetails>this.workRequestViewModel.workrequestDetails).connectingToExistingSewer;
  }

  set connectingToExistingSewer(v: boolean) {
    (<WorkrequestCmpDetails>this.workRequestViewModel.workrequestDetails).connectingToExistingSewer = v;
  }

  get connectingToNewSewer(): boolean {
    return (<WorkrequestCmpDetails>this.workRequestViewModel.workrequestDetails).connectingToNewSewer;
  }

  set connectingToNewSewer(v: boolean) {
    (<WorkrequestCmpDetails>this.workRequestViewModel.workrequestDetails).connectingToNewSewer = v;
  }

  get dischargeOfTradeWaste(): boolean {
    return (<WorkrequestCmpDetails>this.workRequestViewModel.workrequestDetails).dischargeOfTradeWaste;
  }

  set dischargeOfTradeWaste(v: boolean) {
    (<WorkrequestCmpDetails>this.workRequestViewModel.workrequestDetails).dischargeOfTradeWaste = v;
  }

  set applicationDate(v: string) {
    this.workRequestViewModel.applicationDate = v;
  }

  get totalOrderAmount(): number {
    return (<WorkrequestCmpDetails>this.workRequestViewModel.workrequestDetails).totalOrderAmount;
  }

  get applicationDate(): string {
    return this.workRequestViewModel.applicationDate;
  }

  get errorMessage(): string {
    return this.workRequestViewModel.errorMessage;
  }

  set errorMessage(v: string) {
    this.workRequestViewModel.errorMessage = v;
  }


   displayErrorMessage(): string {
    this.serviceTappingSizeControl.markAsTouched();
    this.serviceTappingFlowControl.markAsTouched();
    this.serviceTappingQtyControl.markAsTouched();
    // this.fireServiceSizeControl.markAsTouched();
    // this.fireServiceFlowControl.markAsTouched();
    // this.fireServiceQtyControl.markAsTouched();
    this.mainMeterSizeControl.markAsTouched();
    this.mainMeterFlowControl.markAsTouched();
    this.mainMeterQtyControl.markAsTouched();
    this.checkMeterRSizeControl.markAsTouched();
    this.checkMeterCSizeControl.markAsTouched();
    this.existingServiceDetailsControl.markAsTouched();
    this.existingMeterNumbersSelectedControl.markAsTouched();
    this.existingMeterNumbersControl.markAsTouched();
    this.recycledTappingSizeControl.markAsTouched();
    this.recycledTappingFlowControl.markAsTouched();
    this.recycledTappingQtyControl.markAsTouched();
    this.recycledMainMeterSizeControl.markAsTouched();
    this.recycledCheckMeterRSizeControl.markAsTouched();
    this.descriptionOfWorkControl.markAsTouched();
    

    this.errorMessage = null;

    let errorText = '';

   // if (this.serviceTappingSizeControl.invalid) {
   //   errorText += 'Please enter drinking water service tapping size from 0 to ' + this.maximumServiceSize + ' mm' + '<br>';
    //}
    if (this.serviceTappingFlowControl.invalid) {
      errorText += 'Please enter drinking water service tapping flow rate from 0 to ' + this.maximumServiceFlowRate + ' L/s' + '<br>';
    }
    if (this.serviceTappingQtyControl.invalid) {
      errorText += 'Please enter drinking water service quantity from 0 to ' + this.maximumServiceQty + '<br>';
    }

    // if (this.fire) {
    //   if (this.fireServiceSizeControl.invalid) {
    //     errorText += 'Please enter fire service tapping size from 0 to ' + this.maximumFireServiceSize + ' mm' + '<br>';
    //   }
    //   if (this.fireServiceFlowControl.invalid) {
    //     errorText += 'Please enter fire service flow rate from 0 to ' + this.maximumFireServiceFlowRate + ' L/s' + '<br>';
    //   }
    //   if (this.fireServiceQtyControl.invalid) {
    //     errorText += 'Please enter fire service quantity from 0 to ' + this.maximumFireServiceQty + '<br>';
    //   }
    // }

    if (this.mainMeterSizeControl.invalid) {
      errorText += 'Please enter drinking water main meter size from 0 to ' + this.maximumMainMeterSize + ' mm' + '<br>';
    }
    if (this.mainMeterFlowControl.invalid) {
      errorText += 'Please enter drinking water main meter flow rate from 0 to ' + this.maximumMainMeterFlowRate + ' L/s' + '<br>';
    }
    if (this.mainMeterQtyControl.invalid) {
      errorText += 'Please enter drinking water main meter quantity from 0 to ' + this.maximumMainMeterQty + '<br>';
    }

    if (this.checkMeterRSizeControl.invalid) {
      errorText += 'Please enter residential check meter size from 0 to ' + this.maximumCheckMeterRSize + ' mm' + '<br>';
    }

    if (this.checkMeterCSizeControl.invalid) {
      errorText += 'Please enter commercial check meter size from 0 to ' + this.maximumCheckMeterCSize + ' mm' + '<br>';
    }

    if (this.existingServiceDetailsControl.hasError('maxlength')) {
      errorText += 'Details of existing water service/s cannot exceed ' +
        this.existingWaterServiceControlMaxLength + ' characters' + '<br>';
    }

    if (this.existingMeterNumbersControl.hasError('maxlength')) {
      errorText += 'Existing water meter Number/s - backflow prevention field cannot exceed ' +
        this.existingMeterNumbersControlMaxLength + ' characters' + '<br>';
    }

    if (this.recycledTappingSizeControl.invalid) {
      errorText += 'Please enter recycled water tapping size from 0 to ' + this.maximumRecycledTappingSize + ' mm' + '<br>';
    }
    if (this.recycledTappingFlowControl.invalid) {
      errorText += 'Please enter recycled water tapping flow rate from 0 to ' + this.maximumRecycledTappingFlowRate + ' L/s' + '<br>';
    }
    if (this.recycledTappingQtyControl.invalid) {
      errorText += 'Please enter recycled water tapping quantity from 0 to ' + this.maximumRecycledTappingQty + '<br>';
    }

    if (this.recycledMainMeterSizeControl.invalid) {
      errorText += 'Please enter recycled water main meter size from 0 to ' + this.maximumRecycledMainMeterSize + ' mm' + '<br>';
    }

    if (this.recycledCheckMeterRSizeControl.invalid) {
      errorText += 'Please enter recycled water check meter size from 0 to ' + this.maximumRecycledCheckMeterRSize + ' mm' + '<br>';
    }

    if (this.descriptionOfWorkControl.invalid) {
      if (this.descriptionOfWorkControl.hasError('maxlength')) {
        errorText += 'Description of work cannot exceed ' + this.descriptionOfWorkControlMaxLength + ' characters' + '<br>';
      }
      if (this.descriptionOfWorkControl.hasError('required')) {
        errorText += 'Please enter description of work' + '<br>';
      }
    }

    this.markValidationControlsAsUntouched();
    this.errorMessage = errorText.length > 0 ? errorText : null;
    return errorText;
  }

  markValidationControlsAsUntouched() {
    this.serviceTappingSizeControl.markAsUntouched();
    this.serviceTappingFlowControl.markAsUntouched();
    this.serviceTappingQtyControl.markAsUntouched();
    // this.fireServiceSizeControl.markAsUntouched();
    // this.fireServiceFlowControl.markAsUntouched();
    // this.fireServiceQtyControl.markAsUntouched();
    this.mainMeterSizeControl.markAsUntouched();
    this.mainMeterFlowControl.markAsUntouched();
    this.mainMeterQtyControl.markAsUntouched();
    this.checkMeterRSizeControl.markAsUntouched();
    this.checkMeterCSizeControl.markAsUntouched();
    this.existingServiceDetailsControl.markAsUntouched();
    this.existingMeterNumbersSelectedControl.markAsUntouched();
    this.existingMeterNumbersControl.markAsUntouched();
    this.recycledTappingSizeControl.markAsUntouched();
    this.recycledTappingFlowControl.markAsUntouched();
    this.recycledTappingQtyControl.markAsUntouched();
    this.recycledMainMeterSizeControl.markAsUntouched();
    this.recycledCheckMeterRSizeControl.markAsUntouched();
    this.descriptionOfWorkControl.markAsUntouched();
    // this.loadFees();
  }

  clearDevelopmentType() {
    if (this.zones) {
      this.zones.selectedItemId = 0;
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/create-application/cmp-form/workrequest-cmp/workrequest-cmp.component.ts